import type { ComponentType } from 'react';
import { SiApple, SiAndroid } from 'react-icons/si';
import { Smartphone } from 'lucide-react';

// Single source for platform → brand glyph + label, read by the Games cards,
// the Games filter pills, and the offer detail modal. Real Apple/Android logos
// (react-icons/si), monochrome via currentColor so they inherit the tag styling.
const PLATFORM_META: Record<string, { Icon: ComponentType<{ className?: string }>; label: string }> = {
  ios: { Icon: SiApple, label: 'iOS' },
  android: { Icon: SiAndroid, label: 'Android' },
  all: { Icon: Smartphone, label: 'All' },
};

/** Inline platform glyph + label (e.g. Apple logo + "iOS"). */
export function PlatformTag({
  platform,
  label,
  iconClassName = 'w-3 h-3',
}: {
  platform: string | undefined;
  label?: string;
  iconClassName?: string;
}) {
  const meta = PLATFORM_META[(platform ?? '').toLowerCase()] ?? PLATFORM_META.all;
  return (
    <span className="inline-flex items-center gap-1">
      <meta.Icon className={iconClassName} aria-hidden />
      {label ?? meta.label}
    </span>
  );
}
